<template>
  <div class="topoGeral">
    <div class="topo p-2 pb-1" :style="`background-color:${temaCor.topoApp}`">
      <!--b-row>
        <b-col>
          <font-awesome-icon icon="times" />
        </b-col>
        <b-col class="text-right">
          <font-awesome-icon :icon="['fa', 'question-circle']" class="mr-2" />Ajuda
        </b-col>
      </b-row-->
      <b-row v-if="decoded.tipo == 'Consultor'" class="my-1">
        <!--b-col class="text-center">
          <div class="iconeChart mt-4 ml-3 mb-2">
            <img src=" https://bboneapp.s3.amazonaws.com/mobile/grafico.png" />
          </div>
          <span>Análise</span>
        </b-col-->
        <b-col class="text-center" cols="12">
          <img
            src="data:image/png;base64,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"
            alt="Avatar"
            class="rounded-circle avatar border border-white"
          />
          <!--div class="nota">
            <b-badge variant="light ">8.89</b-badge>
          </div-->
          <h3 class="mt-2 mb-1 text-white">{{ decoded.nome }}</h3>
          <h5 class="my-0 py-0 text-white">Consultor</h5>

          <!-- Alterna entre empresas -->
          <!-- Removido (06/06): A alternação da empresa vai está disponível apenas no ADM -->
          <!-- <div class="alternar-empresa" v-if="listEmpresas.length > 1">
            <span>Empresa Atual: {{ currentEmpresa }}</span>
            <button @click="changeEmpresa()">Mudar</button>
          </div> -->
        </b-col>
        <!--b-col class="text-center">
          <div class="iconeChart mt-4 ml-3 mb-2">
            <img src=" https://bboneapp.s3.amazonaws.com/mobile/carteira.png" />
          </div>
          <span>Trabalho</span>
        </b-col-->
      </b-row>
      <b-row v-else class="my-1">
        <b-col
          style="
            background-color: #fff;
            border-radius: 5px;
            margin: 0px 15px;
            padding: 10px 0;
          "
        >
          <b-row>
            <b-col cols="4" class="text-center">
              <router-link :to="'/dashboard'"
                ><img height="60" :src="logo"
              /></router-link>
            </b-col>
            <b-col class="text-right mr-3">
              <div @click="openMenuLateral()" :class="`icone mb-2 `">
                <font-awesome-icon
                  :icon="['fa', 'bars']"
                  class="text-secondary"
                />
              </div>
              Olá, <span class="nome">{{ nome }}</span></b-col
            >
          </b-row>
        </b-col>
      </b-row>
    </div>
    <MenuInterno
      v-if="decoded.tipo != 'Consultor'"
      :decoded="decoded"
    ></MenuInterno>
  </div>
</template>

<!-- eslint-disable -->
<script>
import jwt from 'jsonwebtoken';
import colors from './../services/colors';
import MenuInterno from './MenuInterno';
import {
  // getCurrentNameEmpresa,
  getListEmpresas,
} from './../services/multiple-empresa';

export default {
  name: 'DashBoard',
  data() {
    return {
      icone: 'faSpinner',
      decoded: {},
      logo: 'https://bboneapp.s3.amazonaws.com/evo-color.png',
      styleTamanho: {
        height: '350px',
      },
      temaCor: {},
      nome: '',
      listEmpresas: [],
      currentEmprea: '',
    };
  },
  methods: {
    formataNome(nome) {
      var aux = '';
      if (nome) aux = nome.split(' ')[0];
      return aux;
    },
    openMenuLateral() {
      this.$emit('OpenMenuLateral', true);
    },
    openDecoded() {
      this.temaCor = colors.getColorsTema();
      this.logo = localStorage.getItem('logo');
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.nome = this.formataNome(this.decoded.nome);
      }
    },
    changeEmpresa() {
      this.$router.replace(`/login-empresa`);
    },
  },
  mounted() {
    this.openDecoded();
    this.listEmpresas = getListEmpresas();
    // this.currentEmpresa = getCurrentNameEmpresa();
  },
  components: { MenuInterno },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  overflow-x: hidden;
  background: none !important;
}
.topoGeral {
  background-color: #e9e9ea;
}
.topo {
  font-size: 11px;
}

.topo .nome {
  font-size: 16px;
  font-family: 'robotobold';
}

.topo .icone {
  vertical-align: middle;
  font-size: 28px;
}

#app {
  margin-top: 0;
}
.iconeChart {
  width: 50px;
  height: 50px;
  text-align: center;
  vertical-align: middle;
  font-size: 18px;
}
.iconeChart img {
  width: 100%;
}
.avatar {
  width: 80px;
  height: 80px;
  /*position: relative;*/
}
.nota {
  margin-top: -10px;
  /* clear: both;
  position: relative;*/
}
.topo h3 {
  font-size: 15px;
  font-weight: bold;
}

.topo h5 {
  font-size: 11px;
}

.alternar-empresa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #0090cf;
  border-radius: 10px;
  margin-top: 8px;
  padding: 8px;
}

.alternar-empresa span {
  color: white;
  display: block;
}

.alternar-empresa button {
  color: white;
  padding: 8px;
  background: #ffa857;
  border-radius: 4px;
  border: none;
}
</style>
